import { createContext, useContext } from 'react';
export const ExperimentsContext = createContext(undefined);
export const useExperiments = ()=>{
    const experiments = useContext(ExperimentsContext) || {};
    return {
        experiments,
        // mirrors ReadOnlyExperiments.enabled from @wix/wix-experiments: the bag
        // holds raw conduction values, so conductor feature toggles arrive as 'B'
        isExperimentEnabled: (spec)=>experiments[spec] === true || experiments[spec] === 'true' || experiments[spec] === 'B'
    };
};

//# sourceMappingURL=experiments-context.js.map